import { setLoaded, setActive, setEnabled, setUiOverlapped, isUiOverlapped } from './AppStatus';
import { readOptions, options } from './Options';
import { on, off } from '@/utils/GlobalEventDispatcher';
import { setupExternalEvents } from '@/service/ExtEvents';
//import { setupExternalEvents } from '@/service/ExtEventsMock';
import { AppEvents, INTERNAL_EVENTS } from './AppStatus';

import { SERVER_EVENTS, ServerMode, useServer, type ServerOptions } from '@/service/Server';
import type { CoinInfo } from '@/types/types';
import { campaign, coinInfo, playerWin } from './Model';
import { useDropAPI } from '@/composables/useDropAPI';
// import { useDropAPIMock } from '@/composables/useDropAPIMock';
import { switchLanguage } from '@/i18n';
// import { sentryHelper } from '@/utils';

//import { initConsumer } from '@/service/SocketHelper';

//need to be sure that widget is loaded before Lobby
let server: any;

export const initApp = () => {
	readOptions();
	setupExternalEvents();
	on(AppEvents.APP_RUN, handleRun);
	server = useServer(options, useDropAPI(options));
	//server = useServer(options, useDropAPIMock());
	// sentryHelper.init(options);
	switchLanguage(options?.locale, options?.fe_script_url);
	setLoaded(true);
	setActive(false);
	setEnabled(false);
	setUiOverlapped(false);
};

//loaded - app is loaded, and run all services

//here come event from lobby and  start interaction with server

const handleRun = async (eventName: string, data: any) => {
	off(AppEvents.APP_RUN, handleRun);

	//on(SERVER_EVENTS.CAMPAIGN_UPDATE, handleCampaignUpdate);
	on(SERVER_EVENTS.COIN_UPDATE, handleCoinInfo);
	on(SERVER_EVENTS.ERROR, handleServerError);
	on(SERVER_EVENTS.PLAYER_WIN, handlePlayerWin);
	on(SERVER_EVENTS.CHANGE_MODE, handleServerChangeMode);

	on(INTERNAL_EVENTS.CONFIRM_PLAYER_WIN, handleConfirmPlayerWin);

	// console.log('Handle run ?????');
	setEnabled(true);
	await server.start();
};

//Mode change
const handleServerChangeMode = (eventName: string, data: any) => {
	// console.log('Campaign update ...... ', data.campaign);
	if (data.mode === ServerMode.HIDDEN) {
		setActive(false);
	} else {
		// console.log('APP CONTROLLER handleCampaignUpdate set Active TRUE', data);

		campaign.value = data.campaign;
		//??????
		setActive(true);
		// console.log('Set Enabled from handleServerChangeMode: ', !isUiOverlapped.value);
		//setEnabled(!isUiOverlapped.value);
	}
};

const handleCoinInfo = (eventName: string, data: any) => {
	if (data) {
		coinInfo.value = data as CoinInfo;
	}
};

const handleServerError = (eventName: string, error: any) => {
	console.error(error);
};

//Player win
const handlePlayerWin = (eventName: string, data: any) => {
	if (data) {
		playerWin.value = data;
	}
};

const handleConfirmPlayerWin = (eventName: string, data: any) => {
	server.confirmPlayerWin(playerWin.value);
	playerWin.value = null;
	// if (campaign.value && campaign.value.player_joined) {
	// 	server.getPlayerWin();
	// }
};

const handleEnable = (eventName: string, data: any) => {
	setEnabled(true);
};

//it will come from server
const handleDisable = (eventName: string, data: any) => {
	setEnabled(false);
};

const handleUiOverlap = (eventName: string, data: any) => {
	setUiOverlapped(data); //TODO remove isOverlapped
	//setActive(!data);

	if (data) {
		server.stop();
		if (coinInfo.value) {
			coinInfo.value = { ...coinInfo.value, total_remaining_prizes: 0, max_prize: 0 };
		}
	} else {
		server.start();
	}
};

on(AppEvents.APP_UI_OVERLAP, handleUiOverlap);

on(AppEvents.APP_DISABLE, handleDisable);

on(AppEvents.APP_ENABLE, handleEnable);
